import request from "@/utils/http";

export function logonUnicom(params = {}) {
    return request({
        url: '/Unicom/logon',
        method: 'post',
        data: params
    })
}

export function damageConfig2(params = {}) {
    return request({
        url: '/Unicom/damageConfig2',
        method: 'post',
        data: params
    })
}

export function getPhoneBrand(params = {}) {
    return request({
        url: '/Index/getPhoneBrand',
        method: 'post',
        data: params
    })
}
export function getPhoneModel(params = {}) {
    return request({
        url: '/Index/getPhoneModel',
        method: 'post',
        data: params
    })
}

export function getPhoneRam(params = {}) {
    return request({
        url: '/Index/getPhoneRam',
        method: 'post',
        data: params
    })
}

export function changePrice(params = {}) {
    return request({
        url: '/Unicom/changePrice',
        method: 'post',
        data: params
    })
}

export function setOrderClaims(params = {}) {
    return request({
        url: '/Unicom/setOrderClaims',
        method: 'post',
        data: params
    })
}

export function orderList(params = {}) {
    return request({
        url: '/Unicom/orderList',
        method: 'post',
        data: params
    })
}

export function getClaims(params = {}) {
    return request({
        url: '/Unicom/getClaims',
        method: 'post',
        data: params
    })
}

export function getFinish(params = {}) {
    return request({
        url: '/Unicom/getFinish',
        method: 'post',
        data: params
    })
}

export function setPlanes(params = {}) {
    return request({
        url: '/Unicom/setPlanes',
        method: 'post',
        data: params
    })
}

